import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { contactsColorKeys } from './_colors'

const colors = contactsColorKeys.Contacts.ContactsListEmptyNotice
export enum ContactsListEmptyNoticeVariants {
  'search' = 'search',
}
const ContactListEmptyNoticeParts = [
  'container',
  'icon',
  'warningText',
  'descriptionText',
  'searchContextText',
  'contentStack',
] as const

const helpers = createMultiStyleConfigHelpers(ContactListEmptyNoticeParts)

export const ContactsListEmptyNoticeStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      width: '100%',
      height: '100%',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      bg: colors.BackgroundColor,
      pt: '2.5rem',
      px: '1.25rem',
    },
    icon: {
      height: 49,
      width: 66,
      boxSize: 'auto',
      color: colors.Icon,
    },
    warningText: {
      textAlign: 'center',
      textStyle: textStyleKeys.Body1_Bold,
      color: colors.FontColor.WarningText,
    },
    descriptionText: {
      textAlign: 'center',
      color: colors.FontColor.DescriptionText,
      textStyle: textStyleKeys.Body2,
    },
    searchContextText: {
      textAlign: 'center',
      color: colors.FontColor.SearchContextText,
    },
    contentStack: {
      gap: '0.5rem',
    },
  },
  variants: {
    search: {
      icon: {
        height: 54,
        width: 54,
      },
    },
  },
})

export const useContactsListEmptyNoticeStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ContactListEmptyNoticeParts>(
    getName({ ContactsListEmptyNoticeStyle }),
    props,
  )
}
